import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import FormInput from 'components/forms/FormInput';
import CountBadge from '../../CounBadge';
import type { SupplierRequestDraftItem } from '../model/types';

interface RequestItemsTableRowProps {
    item: SupplierRequestDraftItem;
    index: number;
    editCountIndex: number | null;
    setEditCountIndex: (index: number | null) => void;
    onSaveCount: (index: number, value: string | number) => void;
    onRemove: (index: number) => void;
    disabled?: boolean;
    showActions?: boolean;
    showReceived?: boolean;
}

const RequestItemsTableRow = ({
    item,
    index,
    editCountIndex,
    setEditCountIndex,
    onSaveCount,
    onRemove,
    disabled = false,
    showActions = true,
    showReceived = false,
}: RequestItemsTableRowProps) => {
    const { t } = useTranslation(['Warehouses']);
    const received = Number(item.receivedCount || 0);

    return (
        <tr>
            <td data-label={t('supplierRequests.create.colName')}>{item.prodName}</td>
            <td data-label={t('supplierRequests.create.colArticle')}>
                <span className="text-muted">{item.prodArticle || '—'}</span>
            </td>
            <td className="text-end" data-label={t('supplierRequests.create.colCount')}>
                {editCountIndex === index && !disabled ? (
                    <FormInput
                        compact
                        showForm
                        setShowForm={(show) => {
                            if (!show) setEditCountIndex(null);
                        }}
                        defaultValue={Number(item.itemCount || 0)}
                        decimalPlaces={2}
                        callBack={(value) => onSaveCount(index, value)}
                    />
                ) : (
                    <span
                        className={disabled ? '' : 'cursor-pointer'}
                        onClick={() => {
                            if (!disabled) setEditCountIndex(index);
                        }}
                    >
                        <CountBadge count={item.itemCount} />
                    </span>
                )}
            </td>
            {showReceived && (
                <td className="text-end" data-label={t('supplierRequests.create.colReceived')}>
                    <CountBadge count={received} />
                </td>
            )}
            {showActions && (
                <td className="text-end" data-label={t('supplierRequests.create.colActions')}>
                    <Button
                        size="sm"
                        variant="light-danger"
                        disabled={disabled}
                        onClick={(e) => {
                            e.currentTarget.blur();
                            onRemove(index);
                        }}
                    >
                        <i className="bi bi-trash3"></i>
                    </Button>
                </td>
            )}
        </tr>
    );
};

export default RequestItemsTableRow;
